import React, { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UseCommonService from '../commonService/commonService'; 
import messageService from '../message/messageService';

interface GuardProps {
  children: any;
}

const LayoutGuard: React.FC<GuardProps>  = ({ children }) => {
  const navigate = useNavigate();
  const commonService = UseCommonService();

  useEffect(() => {
    if (!commonService.getToken()) {
      navigate('/login'); 
      localStorage.clear();
      // const messageServices = messageService();
      // messageServices.toast('info', messageServices.message.loginAgain);

    }
  }, [commonService, navigate]);


  return commonService.getToken() ? children : null;
};

export default LayoutGuard;
